import { adaptListOfNamesToCheckboxOptions } from '@/helpers';

const evaporationOptions = {
  first: { prepend: 'Material' },
  second: {
    prepend: 'Thickness',
    append: 'nm',
    type: 'text',
  },
};

const gasDosingOptions = {
  first: { prepend: 'Gas name / Purity' },
  second: {
    prepend: 'Gas amount',
    append: 'cm^3',
    type: 'number',
  },
};

const photonPolarisationOptions = [
  {
    name: 'Linear horizontal',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Circular / Eliptical',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Linear vertical',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Linear skewed',
    buttonVariant: 'outline-info',
  },
];

const detectionModesOptions = [
  {
    name: 'ARPES',
    text: 'Angle Resolved Photoelectron Spectroscopy (ARPES)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'In Expert Commissioning Access: Spin-ARPES',
    text: 'In Expert Commissioning Access: Spin and Angle Resolved Photoelectron Spectroscopy (Spin-ARPES)',
    buttonVariant: 'outline-info',
  },
];

const experimentTypeOptions = [
  {
    name: 'ARPES',
    text: 'Angle Resolved Photoelectron Spectroscopy (ARPES)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'XPS',
    text: 'X-ray Photoelectron Spectroscopy (XPS)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'CD-ARPES',
    text: 'Circular Dichroism (CD-ARPES)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'ResARPES',
    text: 'Resonance Photoelectron Spectroscopy (ResARPES)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Spin-ARPES',
    text: 'Spin and Angle Resolved Photoelectron Spectroscopy (Spin-ARPES)',
    buttonVariant: 'outline-info',
  },
];

const cryogenicLiquidsOptions = adaptListOfNamesToCheckboxOptions([
  'None', 'LN2', 'LHe',
]);

const samplePreparationOptions = [
  {
    name: 'Cleaving',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Exfoliation',
    buttonVariant: 'outline-info',
  },
  {
    name: 'In situ',
    buttonVariant: 'outline-info',
  },
];

const evaporatorOptions = [
  {
    text: 'Available equipment',
    value: 'Available equipment',
    buttonVariant: 'outline-info',
  },
  {
    text: 'Own',
    value: 'Own',
    buttonVariant: 'outline-info',
  },
];

const ownEvaporatorOptions = {
  first: { prepend: 'Port' },
  second: {
    prepend: 'Length',
    append: 'mm',
    type: 'number',
  },
};

const detectionMethodsOptions = [
  {
    name: 'mini LEED',
    buttonVariant: 'outline-info',
  },
  {
    name: 'RGA',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Quartz balance',
    buttonVariant: 'outline-info',
  },
  {
    name: 'None of these',
    buttonVariant: 'outline-info',
  },
];

const insertingToChamberOptions = [
  {
    name: 'Vacuum suitcase',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Load Lock',
    buttonVariant: 'outline-info',
  },
];

const vacuumSuitcaseOptions = {
  first: {
    prepend: 'Type',
    type: 'text',
    model: 'type',
  },
  second: {
    prepend: 'Parameters',
    type: 'text',
    model: 'parameters',
  },
  third: {
    prepend: 'Dimension',
    append: 'mm',
    type: 'text',
    model: 'dimension',
  },
  fourth: {
    prepend: 'Flange',
    type: 'text',
    model: 'flange',
  },
};

export {
  evaporationOptions,
  gasDosingOptions,
  photonPolarisationOptions,
  detectionModesOptions,
  experimentTypeOptions,
  cryogenicLiquidsOptions,
  samplePreparationOptions,
  evaporatorOptions,
  ownEvaporatorOptions,
  detectionMethodsOptions,
  insertingToChamberOptions,
  vacuumSuitcaseOptions,
};
